import React, { Component } from 'react';
import {
  Nav,
  NavItem,
  NavbarToggler,
  NavbarBrand,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from 'reactstrap';

import * as Constant from '../../constants/AppConstants';
import axios from 'axios';

class Header extends Component {

  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.navigateToLogin = this.navigateToLogin.bind(this);
    this.logout = this.logout.bind(this);
    this.verifyAuthToken = this.verifyAuthToken.bind(this);
    this.toggleLoggedOutModal = this.toggleLoggedOutModal.bind(this);
    this.state = {
      dropdownOpen: false,
      userData: [],
      loggedOutModal: false,
    };
  }

  componentDidMount() {
    // this.verifyAuthToken();
    this.getUserDetails();
  }

  verifyAuthToken() {
    var self = this;
    var querystring = require('querystring');
    var payload = querystring.stringify({
      mode: Constant.VERIFY_TOKEN_MODE,
      auth_token: window.localStorage.getItem(Constant.AUTH_TOKEN),
      token: window.localStorage.getItem(Constant.TOKEN)
    })
    axios({
      method: 'post',
      url: Constant.API_URL,
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
      },
      withCredentials: false,
      data: payload
    })
      .then(function (response) {
        // console.log(response);
        if (response.status == 200) {
          self.getUserDetails();
        } else {
          self.logout();
        }
      })
      .catch(function (error) {
        self.logout();
      });
  }

  getUserDetails() {
    var self = this;
    var querystring = require('querystring');
    var payload = querystring.stringify({
      mode: Constant.GET_DASHBOARD_DATA
    })
    // console.log("Auth token for dashboard1: " + window.localStorage.getItem(Constant.AUTH_TOKEN));
    axios({
      method: 'post',
      url: Constant.API_URL,
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
        'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
        'token': window.localStorage.getItem(Constant.TOKEN)
      },
      withCredentials: false,
      data: payload
    })
      .then(function (response) {
        if (response.status == 200) {
          self.setState(prevState => ({
            userData: response.data.user_details
          }));
        } else if (response.data.error === "Invalid auth token") {
          // console.log(response);
          self.toggleLoggedOutModal();
        } else if (response.data.error === "Login Expired") {
          // console.log(response);
          self.toggleLoggedOutModal();
        } else {
          // console.log(response);
        }
      })
      .catch(function (error) {
        // console.log("Error");
        // console.log(error);
      });
  }

  toggleLoggedOutModal() {
    this.setState({
      loggedOutModal: !this.state.loggedOutModal,
      mail_sent: false,
      mail_unable_to_send: false,
    })
  }

  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  navigateToLogin() {
    this.props.history.push('/login');
  }

  sidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-hidden');
  }

  sidebarMinimize(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-minimized');
  }

  mobileSidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-mobile-show');
  }

  asideToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('aside-menu-hidden');
  }

  logout() {
    var self = this;
    var querystring = require('querystring');
    var payload = querystring.stringify({
      mode: Constant.MODE_LOGOUT
    })
    // console.log("Auth token: " + window.localStorage.getItem(Constant.AUTH_TOKEN));
    axios({
      method: 'post',
      // url: 'https://devapi.stasheasy.com/Admin/services/',
      url: 'https://api.stashfin.com/Admin/services',
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
        'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
        'token': window.localStorage.getItem(Constant.TOKEN)
      },
      withCredentials: false,
      data: payload
    })
      .then(function (response) {
        if (response.status == 200) {
          // console.log(response);
          window.localStorage.setItem(Constant.AUTH_TOKEN, "");
          window.localStorage.setItem(Constant.TOKEN, "");
          window.localStorage.setItem(Constant.IS_LOGGED_IN, false);
          window.localStorage.setItem(Constant.ORG_ID, "");
          self.navigateToLogin();
        } else {
          // console.log(response);
          window.localStorage.setItem(Constant.AUTH_TOKEN, "");
          window.localStorage.setItem(Constant.TOKEN, "");
          window.localStorage.setItem(Constant.IS_LOGGED_IN, false);
          window.localStorage.setItem(Constant.ORG_ID, "");
          self.navigateToLogin();
        }
      })
      .catch(function (error) {
        // console.log(error);
        window.localStorage.setItem(Constant.AUTH_TOKEN, "");
        window.localStorage.setItem(Constant.TOKEN, "");
        window.localStorage.setItem(Constant.IS_LOGGED_IN, false);
        window.localStorage.setItem(Constant.ORG_ID, "");
        self.navigateToLogin();
      });

  }

  navigateToLoanDetails() {
    this.props.history.push('/Login');
  }


  refreshPage() {
    window.location.reload()
  }
// check

  render() {
    return (
      <header className="app-header stash-logo  navbar">
        <a href="/#/dashboard"  >
          <NavbarBrand style={{ backgroundSize: 'auto', marginTop: '7px' }} ></NavbarBrand></a>
        <div className="header-nav-menu">
          <a href="/#/dashboard" > <img src={'img/avatars/dashicon.png'} className="img-avatar" />
            Dashboard</a>

             {/* {this.state.userData.user_name != 'finshell_ext' ?   
                <a href="/#/partnerDashboard" > <img src={'img/avatars/partner.png'} className="img-avatar" />
                Partner Dashboard</a>
               : ""   
               }  */}
          <a href="/#/createLoan" > <img src={'img/avatars/loanicon.png'} className="img-avatar" />
            Create New Lead</a>

            {window.localStorage.getItem(Constant.DSA_REPORT_HEADING) == 1 ?  
            <a href="/#/DSAReports" > <img src={'img/avatars/reporticon.png'} className="img-avatar" />
              DSA Reporting</a>      
            :
              ""
            }
          {/* <span>
            {window.localStorage.getItem(Constant.INV_ACC) == 1 ?

              <a href="/#/generateInvoice" > <img src={'img/avatars/invoice.png'} className="img-avatar" />
                Generate Invoice</a>
              :
              ""
            }
          </span> */}
        </div>
        <Nav className="ml-auto" navbar>
            <NavItem>
              <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle} style={{ marginLeft: "-25px" }}>
                <DropdownToggle className="nav-link dropdown-toggle">
                  <img src={'img/avatars/usericon.png'} className="img-avatar" alt="dsapartner@stashfin.com" />
                  <span className="d-md-down-none">{this.state.userData.name}</span>
                </DropdownToggle>
                <DropdownMenu right className={this.state.dropdownOpen ? 'show' : ''}>

                  <DropdownItem divider />
                  <DropdownItem onClick={this.logout}><i className="fa fa-lock"></i> Logout</DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </NavItem>
          </Nav>

          {this.state.loggedOutModal ? 
            this.navigateToLoanDetails() : ''          
          } 

        {/* <Modal isOpen= toggle={this.logout} className={this.props.className}>
          <ModalHeader toggle={this.logout}>Session expired</ModalHeader>
          <ModalBody>
            Session expired, login again
            </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.logout}>Login</Button>
          </ModalFooter>
        </Modal> */}
      </header>
    )
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js